import z from "zod";

export const QuantitySchema = z.number();
export type Quantity = z.infer<typeof QuantitySchema>;
